import { useLazyQuery, useMutation } from "@apollo/client";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  DropdownButton,
  Form,
  Modal,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import playIcon from "../../../assets/images/play-icon.png";
import searchIcon from "../../../assets/images/search.svg";
import warningIcon from "../../../assets/images/warningIcon.svg";
import {
  GET_ALL_LEADS,
  GET_GLOBAL_OUTBOUNDS_FIELDS,
} from "../../../gql/campaign/leads/queries";
import { DELETE_CAMPAIGN_LEADS } from "../../../gql/campaign/leads/mutation";
import {
  GET_CAMPAIGN_DETAILS_BY_ID,
  UPDATE_CAMPAIGN_STATUS,
} from "../../../gql/campaign/mutation";
import { GET_ALL_CAMPAIGN } from "../../../gql/campaign/queries";
import useUnsavedChangeWarning from "../../../hooks/useUnsavedChangeWarning";
import "./CampaignLeadList.scss";
import PaginatedItems from "./CampaignPagination";

const CampaignLeadList = () => {
  const tableHeading = ["Firstname", "Lastname", "Email", "Phone"];
  const [displayNumber, setDisplayNumber] = useState(50);
  const dropDown = [50, 100, 200, 500, 1000];
  const [allCheck, setAllCheck] = useState(false);
  const [displayDeleteBtn, setDisplayDeleteBtn] = useState(false);
  const [deleteLeadModal, setDeleteLeadModal] = useState(false);

  const [enteriesToDelete, setEnteriesToDelete] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [searchTableData, setSearchTableData] = useState([]);

  const [search, setSearch] = useState(false);
  const [searchKeyword, setSearchKeyword] = useState("");

  const [items, setItems] = useState([]);

  // const [itemPerPage, setItemPerPage] = useState(displayNumber);
  const [itemOffsets, setItemOffsets] = useState(0);
  const { id } = useParams();
  const history = useHistory();

  const [allCampaign, setAllCampaign] = useState([]);
  const [clickedCampaign, setClickedCampaign] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [validExt, setValidExt] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [uploadLeadSuccess, setUploadLeadSuccess] = useState(false);
  const [Prompt, setPristine] = useUnsavedChangeWarning();
  const [updateSuccess, setUpdateSuccess] = useState(false);
  const [smShow2, setSmShow2] = useState(false);
  const [updatePlaySuccess, setUpdatePlaySuccess] = useState(false);
  const [deleteSuccess, setDeleteSuccess] = useState(false);

  //eslint-disable-next-line
  const [campaignStarted, setCampaignStarted] = useState(false);
  const [updatePauseSuccess, setUpdatePauseSuccess] = useState(false);
  const unmountingCheckboxRef = useRef();

  const [getAllCampaign] = useLazyQuery(GET_ALL_CAMPAIGN, {
    onCompleted(data) {
      setAllCampaign(data?.getAllCampaign);
    },
  });
  const [getCampaignById] = useMutation(GET_CAMPAIGN_DETAILS_BY_ID, {
    onCompleted(data) {
      if (data?.getAllSequences) {
        setClickedCampaign(data.getAllSequences);

        getAllLeads({
          variables: {
            campaignId: data.getAllSequences.campaignId,
          },
        });
      }
    },
    onError(error) {
      if (error) {
        if (
          error.networkError &&
          typeof window !== "undefined" &&
          !window.navigator.onLine
        ) {
          setErrorMessage("Check Your Network, Your Browser Is Offline");
        }
        if (error.message) {
          setErrorMessage(error.message);
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !");
        }
      }
    },
    fetchPolicy: "network-only",
  });

  // const [uploadLead, { loading }] = useMutation(UPLOAD_LEADS, {
  //   onCompleted(data) {
  //     setUploadLeadSuccess(true);
  //   },
  //   onError(error) {
  //     if (error) {
  //       if (
  //         error.networkError &&
  //         typeof window !== "undefined" &&
  //         !window.navigator.onLine
  //       ) {
  //         setErrorMessage("Check Your Network, Your Browser Is Offline");
  //       }
  //       if (error.message) {
  //         setErrorMessage(error.message);
  //       }
  //       if (!error.message) {
  //         setErrorMessage("Something Went Wrong !");
  //       }
  //     }
  //   },
  // });

  const [updateCampaignStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
    onCompleted(data) {
      if (data?.updateCampaignStatus) {
        setUpdateSuccess(true);
      }
    },
    onError(error) {
      if (error) {
        if (
          error.networkError &&
          typeof window !== "undefined" &&
          !window.navigator.onLine
        ) {
          setErrorMessage("Check Your Network, Your Browser Is Offline");
        }
        if (error.message) {
          setErrorMessage(error.message);
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !");
        }
      }
    },
    refetchQueries: ["GetAllCampaign"],
  });

  const [updateCampaignPlayStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
    onCompleted(data) {
      if (data?.updateCampaignStatus) {
        setClickedCampaign({
          ...clickedCampaign,
          campaignStarted: true,
        });
        setUpdatePlaySuccess(true);
        setCampaignStarted(true);
      }
    },
    onError(error) {
      if (error) {
        if (
          error.networkError &&
          typeof window !== "undefined" &&
          !window.navigator.onLine
        ) {
          setErrorMessage("Check Your Network, Your Browser Is Offline");
        }
        if (error.message) {
          setErrorMessage(error.message);
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !");
        }
      }
    },
    refetchQueries: ["GetAllCampaign"],
  });

  const [updateCampaignPauseStatus] = useMutation(UPDATE_CAMPAIGN_STATUS, {
    onCompleted(data) {
      if (data?.updateCampaignStatus) {
        setClickedCampaign({
          ...clickedCampaign,
          campaignStarted: false,
        });
        setUpdatePauseSuccess(true);
        setCampaignStarted(false);
      }
    },
    onError(error) {
      if (error) {
        if (
          error.networkError &&
          typeof window !== "undefined" &&
          !window.navigator.onLine
        ) {
          setErrorMessage("Check Your Network, Your Browser Is Offline");
        }
        if (error.message) {
          setErrorMessage(error.message);
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !");
        }
      }
    },
    refetchQueries: ["GetAllCampaign"],
  });

  const [getGlobalOutboundFields] = useLazyQuery(GET_GLOBAL_OUTBOUNDS_FIELDS, {
    // onCompleted(data) {
    //     setFields(data?.getGlobalOutboundFieldList)
    // },
    onError(error) {
      if (error) {
        if (
          error.networkError &&
          typeof window !== "undefined" &&
          !window.navigator.onLine
        ) {
          setErrorMessage("Check Your Network, Your Browser Is Offline");
        }
        if (error.message) {
          setErrorMessage(error.message);
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !");
        }
      }
    },
    fetchPolicy: "network-only",
  });
  const [getAllLeads, { loading: tableLoading }] = useLazyQuery(GET_ALL_LEADS, {
    onCompleted(data) {
      setItems(data?.getCampaignLeads);
    },
    onError(error) {
      if (error) {
        if (
          error.networkError &&
          typeof window !== "undefined" &&
          !window.navigator.onLine
        ) {
          setErrorMessage("Check Your Network, Your Browser Is Offline");
        }
        if (error.message) {
          setErrorMessage(error.message);
        }
        if (!error.message) {
          setErrorMessage("Something Went Wrong !");
        }
      }
    },
    fetchPolicy: "network-only",
  });
  const [deleteCampaignLeads, { loading: deletedLoading }] = useMutation(
    DELETE_CAMPAIGN_LEADS,
    {
      onCompleted(data) {
        if (data?.deleteCampaignLeads) {
          setItems(data?.deleteCampaignLeads);
          setEnteriesToDelete([]);
          setAllCheck(false);
          setDeleteSuccess(true);
          setSearch(false);
          setSearchKeyword("");
        }
      },
      onError(error) {
        if (error) {
          if (
            error.networkError &&
            typeof window !== "undefined" &&
            !window.navigator.onLine
          ) {
            setErrorMessage("Check Your Network, Your Browser Is Offline");
          }
          if (error.message) {
            setErrorMessage(error.message);
          }
          if (!error.message) {
            setErrorMessage("Something Went Wrong !");
          }
        }
      },
      fetchPolicy: "network-only",
    }
  );

  useEffect(() => {
    getAllCampaign();
    getGlobalOutboundFields();

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!items) {
      history.push("/campaigns/uploadleads/" + id);
    }

    //eslint-disable-next-line
  }, [items]);

  useEffect(() => {
    if (id) {
      getCampaignById({
        variables: {
          getSequenceArgs: {
            campaignId: id,
          },
        },
      });
    }
    //eslint-disable-next-line
  }, [id]);
  const handleSave = () => {
    try {
      if (!id) {
        return toast.error("Choose Campaign First.", {
          position: "bottom-right",
          closeOnClick: true,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

  if (errorMessage) {
    toast.error(errorMessage, {
      position: "bottom-right",
      closeOnClick: true,
    });
    setErrorMessage("");
  }

  if (uploadLeadSuccess) {
    toast.success("Successfully Saved.", {
      position: "bottom-right",
    });
    setPristine();
    setSelectedFileName();
    setValidExt(false);
    setUploadLeadSuccess(false);
  }

  const handleDeleteCampaign = () => {
    if (!id) {
      setSmShow2(false);
      return toast.error("Choose Campaign First.", {
        position: "bottom-right",
        closeOnClick: true,
      });
    }
    updateCampaignStatus({
      variables: {
        updateCampaignStatusInput: {
          campaignId: id,
          campaignStatus: "DELETE",
        },
      },
    });
  };

  if (updateSuccess) {
    setSmShow2(false);
    setClickedCampaign({});
    history.push("/campaigns/leads");
    toast.success("Campaign Deleted.", {
      position: "bottom-right",
      closeOnClick: true,
    });
    setUpdateSuccess(false);
  }

  const handlePause = () => {
    if (!id) {
      setSmShow2(false);
      return toast.error("Choose Campaign First.", {
        position: "bottom-right",
        closeOnClick: true,
      });
    }
    updateCampaignPauseStatus({
      variables: {
        updateCampaignStatusInput: {
          campaignId: id,
          campaignStatus: "PAUSE",
        },
      },
    });
  };

  const handlePlay = () => {
    if (!id) {
      setSmShow2(false);
      return toast.error("Choose Campaign First.", {
        position: "bottom-right",
        closeOnClick: true,
      });
    }
    updateCampaignPlayStatus({
      variables: {
        updateCampaignStatusInput: {
          campaignId: id,
          campaignStatus: "START",
        },
      },
    });
  };

  if (updatePlaySuccess) {
    toast.success("Campaign Started.", {
      position: "bottom-right",
      closeOnClick: true,
    });
    setUpdatePlaySuccess(false);
  }

  if (updatePauseSuccess) {
    toast.success("Campaign Paused.", {
      position: "bottom-right",
      closeOnClick: true,
    });
    setUpdatePauseSuccess(false);
  }
  const handleLeadDelete = () => {
    if (id && enteriesToDelete.length > 0) {
      deleteCampaignLeads({
        variables: {
          deleteCampaignLeadInput: {
            campaignId: id,
            leadsData: enteriesToDelete,
          },
        },
      });
    }
    setSmShow2(false);
    setDeleteLeadModal(false);
    //eslint-disable-next-line
  };
  useEffect(() => {
    if (deleteSuccess) {
      toast.success("Successfully Deleted.", {
        position: "bottom-right",
      });
    }
    setDeleteSuccess(false);
  }, [deleteSuccess]);
  useEffect(() => {
    setItemOffsets(0);
  }, [displayNumber]);

  useEffect(() => {
    enteriesToDelete.length > 0
      ? setDisplayDeleteBtn(true)
      : setDisplayDeleteBtn(false);
  }, [enteriesToDelete]);
  useEffect(() => {
    if (searchKeyword === "" || searchKeyword === " ") {
      setSearch(false);
    }
  }, [searchKeyword]);
  const unmountingCheckbox = () => {
    if (enteriesToDelete.length > 0) {
      setAllCheck(false);
      setEnteriesToDelete([]);
    }
  };
  unmountingCheckboxRef.current = unmountingCheckbox;
  useEffect(() => {
    unmountingCheckboxRef.current();
  }, [searchKeyword, tableData]);
 

  return (
    <>
      {/* Upper Sidebar */}
      <div className="campaign-sidebar">
        <div className="title">
          <h4>Campaigns</h4>
        </div>
        <div className="campaign_list_container">
          <ul>
            {allCampaign &&
              allCampaign.length > 0 &&
              allCampaign.map((item, i) => {
                if (
                  item?.campaignStatus !== "delete" &&
                  item?.campaignType === "autoScript" &&
                  item?.sequence.length > 0
                ) {
                  return (
                    <li
                      key={item?._id}
                      style={{
                        backgroundColor:
                          item?._id === id ? "#F5F7FB" : "#FFFFFF",
                      }}
                    >
                      <Link
                        to={`/campaigns/leads/${item?._id}`}
                        onClick={() => {
                          // setPristine()
                          setDisplayNumber(50);
                          setEnteriesToDelete([]);
                          setSearchKeyword("");
                          setSearch(false);
                          setAllCheck(false);
                          setClickedCampaign(item);
                        }}
                      >
                        {item?.campaignName}
                      </Link>
                    </li>
                  );
                } else if (
                  item?.campaignStatus !== "delete" &&
                  item?.campaignType === "manualScript"
                ) {
                  return (
                    <li
                      key={item?._id}
                      style={{
                        backgroundColor:
                          item?._id === id ? "#F5F7FB" : "#FFFFFF",
                      }}
                    >
                      <Link
                        to={`/campaigns/leads/${item?._id}`}
                        onClick={() => {
                          // setPristine()
                          setDisplayNumber(50);
                          setEnteriesToDelete([]);
                          setSearchKeyword("");
                          setSearch(false);
                          setAllCheck(false);
                          setClickedCampaign(item);
                        }}
                      >
                        {item?.campaignName}
                      </Link>
                    </li>
                  );
                }
                return false;
              })}
          </ul>
        </div>
        <div className="create-camp-btn">
          <button
            className="solid-button"
            onClick={() => {
              // setIsDirty()
              history.push("/campaign-name");
            }}
          >
            Create New Campaigns
          </button>
        </div>
      </div>

      <div className="campaign-details">
        <div className="title-btn-container">
          <h1>{clickedCampaign?.campaignName}</h1>
          <div className="btn-container">
            <button className="play-pause-btn">
              {
                // clickedCampaign?.campaignStarted === true || campaignStarted === true ?
                clickedCampaign?.campaignStarted === true ? (
                  <span className="pause" onClick={handlePause}>
                    <svg
                      width="13"
                      height="16"
                      viewBox="0 0 13 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.5 1H1V15H4.5V1Z"
                        stroke="#FFB147"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M11.5 1H8V15H11.5V1Z"
                        stroke="#FFB147"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    Pause
                  </span>
                ) : (
                  <span className="play" onClick={handlePlay}>
                    {/* <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.5 1H1V15H4.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                            <path d="M11.5 1H8V15H11.5V1Z" stroke="#FFB147" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg> */}
                    <img src={playIcon} alt="play" width="20" height="20" />
                    Play
                  </span>
                )
              }
            </button>
            {selectedFileName && validExt ? (
              <button className="solid-button" onClick={handleSave}>
                Save
              </button>
            ) : (
              <button
                className="solid-button"
                disabled
                style={{ opacity: "0.7", cursor: "not-allowed" }}
              >
                Save
              </button>
            )}
            {/* <label htmlFor="submit-form_setup" className='solid_button_save_schedule' >Save</label> */}
            {/* <button className='solid-button' onClick={handleSave} >Save</button> */}
            <button className="delete-btn" onClick={() => setSmShow2(true)}>
              <svg
                width="19"
                height="20"
                viewBox="0 0 19 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M0.998047 4.40332H2.86471H17.798"
                  stroke="#0A1E43"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M5.66719 4.39935V2.53268C5.66719 2.03761 5.86385 1.56282 6.21392 1.21275C6.56399 0.862682 7.03878 0.666016 7.53385 0.666016H11.2672C11.7623 0.666016 12.2371 0.862682 12.5871 1.21275C12.9372 1.56282 13.1339 2.03761 13.1339 2.53268V4.39935M15.9339 4.39935V17.466C15.9339 17.9611 15.7372 18.4359 15.3871 18.7859C15.0371 19.136 14.5623 19.3327 14.0672 19.3327H4.73385C4.23878 19.3327 3.76399 19.136 3.41392 18.7859C3.06385 18.4359 2.86719 17.9611 2.86719 17.466V4.39935H15.9339Z"
                  stroke="#0A1E43"
                  strokeWidth="1.2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>
        <ul className="campaign-detail-tabs">
          <li className="active">
            <Link to={id ? `/campaigns/leads/${id}` : "/campaigns/leads"}>
              Leads
            </Link>
          </li>
          <li className="tab_sequence">
            <Link
              to={
                id
                  ? `/campaigns/campaign-details/${id}`
                  : "/campaigns/campaign-details"
              }
            >
              Sequence
            </Link>
          </li>
          <li className="tab_sequence">
            <Link to={id ? `/campaigns/schedule/${id}` : "/campaigns/schedule"}>
              Schedules
            </Link>
          </li>
          <li className="tab_sequence">
            <Link to={id ? `/campaigns/setup/${id}` : "/campaigns/setup"}>
              Setup
            </Link>
          </li>
        </ul>
        {/* Upper Sidebar */}

        {tableLoading ? (
          <Container className=" spinnerCont">
            <div>
              <Spinner animation="border" variant="primary" />
            </div>
          </Container>
        ) : (
          <Row className=" lead-table rounded mx-auto">
            <Row>
              <Col>
                <div className="title-btn-container ">
                  <Button
                    onClick={() => {
                      if (!id) {
                        return toast.error("Choose campaign first.", {
                          position: "bottom-right",
                          closeOnClick: true,
                        });
                      } else {
                        history.push(`/campaigns/uploadleads/${id}?leadTrue`);
                      }
                    }}
                    // to={`/campaigns/uploadleads/${id}?leadTrue`}
                    className="solid-button hoverColor"
                    style={{
                      height: "2.6rem",
                      textDecoration: "none",
                      color: "white",
                    }}
                  >
                    Import Leads
                  </Button>

                  <div className="btn-container my-auto">
                    <form className="d-flex justify-content-start align-items-center search-container border rounded">
                      <input
                        className="form-control h-auto ms-2 p-0"
                        type="text"
                        value={searchKeyword}
                        placeholder="Search"
                        aria-label="Search"
                        style={{ outline: "none", border: "none" }}
                        onChange={(e) => {
                          setSearchKeyword(e.target.value);
                          setSearch(true);

                          setSearchTableData(
                            items.filter((item) =>
                              item?.email
                                ?.toLowerCase()
                                .includes(e.target.value.toLowerCase())
                                ? item?.email
                                    ?.toLowerCase()
                                    .includes(e.target.value.toLowerCase())
                                : item?.firstName
                                    ?.toLowerCase()
                                    .includes(e.target.value.toLowerCase())
                                ? item?.firstName
                                    ?.toLowerCase()
                                    .includes(e.target.value.toLowerCase())
                                : item?.lastName
                                    ?.toLowerCase()
                                    .includes(e.target.value.toLowerCase())
                                ? item?.lastName
                                    ?.toLowerCase()
                                    .includes(e.target.value)
                                : item?.phone?.includes(e.target.value)
                            )
                          );
                        }}
                      />

                      <img
                        src={searchIcon}
                        style={{ width: "1.2rem", margin: "auto 0.5rem" }}
                        alt="Search"
                      />
                    </form>
                    {!search ? (
                      <DropdownButton
                        size="md"
                        id="dropdown-basic-button"
                        title={`Display ${displayNumber}`}
                        variant="success"
                        style={{ padding: "0" }}
                      >
                        {dropDown.map((item, i) => {
                          return (
                            <Dropdown.Item
                              key={i}
                              onClick={() => {
                                setDisplayNumber(item);

                                // displayItems(item)
                              }}
                            >
                              Display {item}
                            </Dropdown.Item>
                          );
                        })}
                      </DropdownButton>
                    ) : (
                      ""
                    )}
                    {displayDeleteBtn ? (
                      <button
                        className="btn-danger btn btn-md mx-3 my-auto"
                        onClick={() => {
                          setDeleteLeadModal(true);
                          setSmShow2(true);
                        }}
                      >
                        Delete
                        {deletedLoading ? (
                          <>
                            {" "}
                            &nbsp;
                            <Spinner
                              as="span"
                              animation="border"
                              size="sm"
                              role="status"
                              aria-hidden="true"
                            />
                          </>
                        ) : (
                          ""
                        )}
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <Row className="mt-3 p-2 ">
                  <Col className="col-1">
                    {" "}
                    <Form.Check
                      className="form-check-custom"
                      style={{ padding: "0" }}
                      value={allCheck}
                      checked={allCheck}
                      onChange={(e) => {
                        setAllCheck(!allCheck);
                        setDisplayDeleteBtn(e.target.value);
                        if (e.target.checked) {
                          if (!search && searchKeyword === "") {
                            setEnteriesToDelete([
                              ...tableData.map((item, i) => {
                                return item.email;
                              }),
                            ]);
                          } else if (search && searchKeyword !== "") {
                            setEnteriesToDelete([
                              ...searchTableData.map((item, i) => {
                                return item.email;
                              }),
                            ]);
                          }
                        } else if (!e.target.checked) {
                          setEnteriesToDelete([]);
                        }

                        // else if(deleteSuccess){
                        //     e.target.checked = false;
                        //   }
                      }}
                    />
                  </Col>
                  {tableHeading.map((item, i) => {
                    return (
                      <Col
                        key={i}
                        className={`${i === 0 ? "col-2" : "col-3"} my-auto`}
                      >
                        <h2 className="lead-table-heading">{item}</h2>
                      </Col>
                    );
                  })}
                  <hr className="mt-3" style={{ height: ".5px" }} />
                </Row>

                {search ? (
                  <Row
                    className={`${
                      searchTableData.length > 0 ? "lead-cont-scroll" : ""
                    }`}
                  >
                    <Col>
                      {searchTableData &&
                        searchTableData.map((item, i) => {
                          return (
                            <Row key={i} className="px-2">
                              <Col className="col-1">
                                <Form.Check
                                  className="form-check-custom"
                                  style={{ padding: "0" }}
                                  aria-label="option 1"
                                  value={i}
                                  checked={
                                    enteriesToDelete.includes(item?.email)
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setEnteriesToDelete([
                                        ...enteriesToDelete,
                                        item?.email,
                                      ]);
                                    } else if (!e.target.checked) {
                                      setEnteriesToDelete([
                                        ...enteriesToDelete.filter((items) =>
                                          items !== item?.email ? item : ""
                                        ),
                                      ]);
                                    }
                                  }}
                                />
                              </Col>

                              <Col className="col-2">
                                {item?.firstName ? (
                                  <h4> {item.firstName} </h4>
                                ) : (
                                  <h4 className="text-danger">Not available</h4>
                                )}
                              </Col>
                              <Col className="col-2">
                                {item?.lastName ? (
                                  <h4> {item.lastName} </h4>
                                ) : (
                                  <h4 className="text-danger">Not available</h4>
                                )}
                              </Col>
                              <Col className="col-4">
                                {item?.email ? (
                                  <h4
                                    style={{
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {" "}
                                    {item.email}{" "}
                                  </h4>
                                ) : (
                                  <h4 className="text-danger">Not available</h4>
                                )}
                              </Col>
                              <Col className="col-3">
                                {item?.phone ? (
                                  <h4> {item.phone} </h4>
                                ) : (
                                  <h4 className="text-danger">Not available</h4>
                                )}
                              </Col>

                              <hr className="mt-3" style={{ height: ".5px" }} />
                            </Row>
                          );
                        })}
                    </Col>
                  </Row>
                ) : (
                  <Row
                    className={`${
                      tableData.length > 0 ? "lead-cont-scroll" : ""
                    }`}
                  >
                    <Col>
                      {tableData &&
                        tableData.map((item, i) => {
                          return (
                            <Row key={i} className="px-2">
                              <Col className="col-1">
                                <Form.Check
                                  className="form-check-custom"
                                  style={{ padding: "0" }}
                                  aria-label="option 1"
                                  value={i}
                                  checked={
                                    enteriesToDelete.includes(item.email)
                                      ? true
                                      : false
                                  }
                                  onChange={(e) => {
                                    if (e.target.checked) {
                                      setEnteriesToDelete([
                                        ...enteriesToDelete,
                                        item.email,
                                      ]);
                                    } else if (!e.target.checked) {
                                      setEnteriesToDelete([
                                        ...enteriesToDelete.filter((items) =>
                                          items !== item.email ? item : ""
                                        ),
                                      ]);
                                    }
                                  }}
                                />
                              </Col>

                              <Col className="col-2">
                                {item?.firstName ? (
                                  <h4> {item.firstName} </h4>
                                ) : (
                                  <h4 className="text-danger">Not available</h4>
                                )}
                              </Col>
                              <Col className="col-2">
                                {item?.lastName ? (
                                  <h4> {item.lastName} </h4>
                                ) : (
                                  <h4 className="text-danger">Not available</h4>
                                )}
                              </Col>
                              <Col className="col-4">
                                {item?.email ? (
                                  <h4
                                    style={{
                                      textOverflow: "ellipsis",
                                      overflow: "hidden",
                                    }}
                                  >
                                    {" "}
                                    {item.email}{" "}
                                  </h4>
                                ) : (
                                  <h4 className="text-danger">Not available</h4>
                                )}
                              </Col>
                              <Col className="col-3">
                                {item?.phone ? (
                                  <h4> {item.phone} </h4>
                                ) : (
                                  <h4 className="text-danger">Not available</h4>
                                )}
                              </Col>

                              <hr className="mt-3" style={{ height: ".5px" }} />
                            </Row>
                          );
                        })}
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
            {!search && tableData ? (
              <Row>
                <Col className="col-2 mx-auto">
                  <PaginatedItems
                    itemsPerPage={displayNumber}
                    currentPageData={(items) => {
                      setTableData(items);
                    }}
                    items={items}
                    itemOffset={itemOffsets}
                    setItemOffset={(item) => setItemOffsets(item)}
                  />
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Row>
        )}
      </div>

      <Modal
        size="md"
        className="warning-modal"
        show={smShow2}
        onHide={() => setSmShow2(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <div className="warning-div">
            <img src={warningIcon} alt="warning" />
            <h2>Warning</h2>
            <p>
              Are you sure you want to delete{" "}
              {deleteLeadModal ? "leads" : "this campaign"}?
            </p>
            <div className="btn-container">
              <button
                className="cancel-btn"
                onClick={() => {
                  setSmShow2(false);
                  setDeleteLeadModal(false);
                }}
              >
                No
              </button>
              <button
                className="solid-button"
                style={{ flex: "0 0 128px" }}
                onClick={() =>
                  deleteLeadModal ? handleLeadDelete() : handleDeleteCampaign()
                }
              >
                Yes
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      {Prompt}
    </>
  );
};
export default CampaignLeadList;
